import React from 'react';
import styled from '@emotion/styled';

import { parseHtml } from '../../helpers';

import { BulletPoint } from '../../../types/types';

const Ul = styled.ul({
  width: '100%',

  // Third Party features list has not border top on the first item
  '&.feature': {
    'li:first-of-type': {
      borderTopWidth: 0,
      paddingTop: 0,
    },
  },
});

const Li = styled.li({
  fontWeight: 'var(--font-weight-regular)',
});

type Props = {
  points: BulletPoint[];
};

export const CtaTpPoints: React.FC<Props> = ({ points }) => {
  if (!(points && points.length)) {
    return null;
  }
  return (
    <Ul className='feature tick' data-testid='mp-product-cta-points'>
      {points?.map((point, i) => (
        <Li key={i}>{parseHtml(point.title)}</Li>
      ))}
    </Ul>
  );
};
